<ng-container [formGroup]="formGroupCampaignTypeData">
  <div class="d-flex align-items-center mat-slide-toggle__wrapper">
    <app-mdb-switch label="Enable Grid View On Donor Side" formControlName="gridView" id="gridView"></app-mdb-switch>
    <div class="d-flex align-items-center ml-2 h-100">
      @if(formGroupCampaignTypeData.controls.gridView.value){
        <i class="fas fa-th mr-2"></i>
      }@else{
        <i class="fas fa-bars mr-2"></i>
      }
      <app-text-popover
        placement="right"
        type="content"
        text="The item options are displayed as a list on the donor side by default. To enable grid view, switch ON."
        title=""
       >
    </app-text-popover>
    </div>
  </div>
  <div class="divider"></div>
</ng-container>